import React from 'react'
import { useTranslation } from 'react-i18next'
import { formatNumberWithCommas } from '../../../../../../_common/functions'
import { Tooltip } from 'react-daisyui'

interface MetricRowProps {
    group: string
    promo: string
    mean: number | string
    lowerBD: number | string
    upperBD: number | string
    vsControl: string
    vsTest: string
    pValue: string
    samplesDesign: number | string
    samplesMeasurement: number | string
    highlight?: boolean
}

const MetricRow: React.FC<any> = ({
    // group,
    // promo,

    // lowerBD,
    // upperBD,
    // vsControl,
    // vsTest,
    // pValue,
    // samplesDesign,
    // samplesMeasurement,
    // highlight,
    title,
    name,
    action,
    total,
    mean,
    samples_in_design,
    samples_in_measurement,
    vs_test,
    vs_ctrl,
    lower_bd,
    upper_bd,
}) => {
    const { t } = useTranslation()
    const badgeClass = ' badge bg-yellow-300 text-grey-500  text-[.52rem] border-none font-normal '

    const generalClass = 'col-span-1 text-center font-semibold   flex justify-center items-center flex-col h-full'
    return (
        <div className="grid grid-cols-12 items-center ">
            <div className="col-span-2 md:col-span-3 border-r py-2 h-full ">
                <div className="grid grid-cols-2 text-[.52rem] text-center h-full">
                    <div className={' leading-3 items-center font-medium col-span-4 md:col-span-1 flex text-start flex-row'}>
                        {(title as string).toLocaleUpperCase()}
                        <br />
                        {name}
                    </div>
                    <div className={`${generalClass}  text-center text-gray-500 text-wrap flex col-span-4 md:col-span-1`}>
                        <Tooltip color="info" message={action} position="top">
                            <p className="line-clamp-2 leading-[1.35] font-normal break-words" title={action}>
                                {action}
                            </p>
                        </Tooltip>
                    </div>
                </div>
            </div>
            <div className="col-span-3 border-r py-2  h-full  ">
                <div className="grid grid-cols-3 text-[.52rem]  h-full ">
                    <div className={generalClass}>{formatNumberWithCommas(+Number(mean)?.toFixed(2)) || '-'}</div>
                    <div className={generalClass}>{formatNumberWithCommas(lower_bd?.toFixed(2)) || '-'}</div>
                    <div className={generalClass}>{formatNumberWithCommas(upper_bd?.toFixed(2)) || '-'}</div>
                </div>
            </div>
            <div className="col-span-2 border-r py-2  h-full ">
                <div className="grid grid-cols-2 text-[.52rem] ">
                    <div className={generalClass + ''}>
                        <p>{vs_ctrl?.value || '-'}</p>
                        {(vs_ctrl?.algo != undefined || null) && (
                            <div className={badgeClass}>
                                {t('P=')} {Number(vs_ctrl?.algo).toFixed(2)}
                            </div>
                        )}
                    </div>
                    <div className={generalClass}>
                        <p>{vs_test?.value || '-'}</p>
                        {(vs_test?.algo != undefined || null) && (
                            <div className={badgeClass}>
                                {t('P=')} {Number(vs_test?.algo).toFixed(2)}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="col-span-4  py-2  h-full ">
                <div className="grid grid-cols-2 text-[.52rem] ">
                    <div className={generalClass}>{formatNumberWithCommas(samples_in_design) || '-'}</div>
                    <div className={generalClass + ' text-[#771F22]'}>{formatNumberWithCommas(samples_in_measurement) || '-'}</div>
                </div>
            </div>
        </div>
    )
}

export default MetricRow
